module.exports = __webpack_public_path__ + "img/dab_teviot.79b4f57e.jpg";